"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _validatorAjv = _interopRequireDefault(require("@rjsf/validator-ajv8"));
require("./style.css");
var _schema = require("./schema");
var _uiSchema = require("./uiSchema");
var _utils = require("../../utils");
var _antd = require("@rjsf/antd");
var _core = require("@rjsf/core");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Form = (0, _core.withTheme)(_antd.Theme);
const NicheFormEngine = props => {
  const [formData, setFormData] = (0, _react.useState)({});
  (0, _react.useEffect)(() => {
    (0, _utils.validateUiSchema)(_schema.schema, _uiSchema.uiSchema);
  }, []);
  let defaultSchema = Object.keys(props.schema).length === 0 && props.schema.constructor === Object ? _schema.schema : props.schema;
  let defaultUiSchema = Object.keys(props.uiSchema).length === 0 && props.uiSchema.constructor === Object ? _schema.schema : props.uiSchema;
  const onChange = e => {
    setFormData(e.formData);
    props?.clearError();
  };
  const handleSubmit = e => {
    props.handleSubmit(e);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Form, {
    transformErrors: _utils.transformFormErrors,
    schema: defaultSchema,
    uiSchema: defaultUiSchema,
    validator: _validatorAjv.default,
    onChange: onChange,
    formData: formData,
    onSubmit: handleSubmit,
    showErrorList: false
  });
};
NicheFormEngine.propTypes = {
  schema: _propTypes.default.object,
  uiSchema: _propTypes.default.object
};
NicheFormEngine.defaultProps = {
  schema: _schema.schema,
  uiSchema: _uiSchema.uiSchema
};
var _default = exports.default = NicheFormEngine;